import PictureImage from '../Common/PictureImage';
import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import './Logistics.css';
import '../ShopifyFulfilment/ShopifyFulfilment.css';

export type LogisticsPageHeroProps = {
  ariaLabel: string;
  imageSrc: string;
  imageAlt?: string;
  titleLight: string;
  titleAccent: string;
  description: ReactNode;
  features?: string[];
  primaryCta?: { label: string; to: string };
  secondaryCta?: { label: string; to: string };
  ctaSlot?: ReactNode;
  className?: string;
};

export default function LogisticsPageHero({
  ariaLabel,
  imageSrc,
  imageAlt = '',
  titleLight,
  titleAccent,
  description,
  features,
  primaryCta,
  secondaryCta,
  ctaSlot,
  className = '',
}: LogisticsPageHeroProps) {
  return (
    <section
      className={`hero-section fba-page-hero logistics-hero${className ? ` ${className}` : ''}`}
      aria-label={ariaLabel}
    >
      <PictureImage
        src={imageSrc}
        alt={imageAlt}
        className="fba-page-hero__bg logistics-hero-img"
        width={1920}
        height={1080}
        decoding="async"
        sizes="(max-width: 768px) 400px, 100vw"
        isHero
      />
      <div className="fba-page-hero__overlay" aria-hidden />
      <div className="fba-page-hero__content">
        <div className="sh-left">
          <h1 className="sh-main-title logistics-hero-title">
            <span className="logistics-hero-title-light">{titleLight}</span>{' '}
            <span className="logistics-hero-title-accent">{titleAccent}</span>
          </h1>
          <div className="sh-desc logistics-hero-desc">{description}</div>
          {features?.length ? (
            <ul className="sh-features logistics-hero-features">
              {features.map((item) => (
                <li key={item} className="sh-feature-item">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden>
                    <path
                      d="M3 9.5l4 4L15 5"
                      stroke="#e07b20"
                      strokeWidth="2.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          ) : null}
          {ctaSlot ?? (
            primaryCta ? (
              <div className="sh-cta-wrapper">
                <Link to={primaryCta.to} className="sh-cta-btn">
                  {primaryCta.label}
                </Link>
                {secondaryCta ? (
                  <Link to={secondaryCta.to} className="logistics-hero-secondary-btn">
                    {secondaryCta.label}
                  </Link>
                ) : null}
              </div>
            ) : null
          )}
        </div>
      </div>
    </section>
  );
}
